var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{staticClass:"flex-grow-1",staticStyle:{"object-fit":"contain","max-width":"100%"},attrs:{"controls":"","src":_vm.src}})
}
var staticRenderFns = []

export { render, staticRenderFns }